import { orderBy } from 'lodash'
import { graphqlApi } from 'src/redux/api/graphql/graphqlApi'
import type { ReduxQuoteInfo, ReduxUserInfo } from 'src/types/apiType'
import { getCostlineFetchFilter } from 'src/utils/fetchUtils'

export const quoteInfoApi = graphqlApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchQuoteInfoByQuoteId: builder.query({
			query: ({
				quoteId,
				userInfo,
			}: {
				quoteId: string
				userInfo: ReduxUserInfo
			}) => ({
				queryName: 'quoteInfoByQuoteId',
				data: {
					quoteId,
					filter: getCostlineFetchFilter(userInfo),
					limit: 3000,
				},
				isList: true,
			}),
			transformResponse: (response: ReduxQuoteInfo[]) => {
				const sortedQuoteInfo = orderBy(
					response,
					['fractionalSortKey'],
					['asc']
				)
				return sortedQuoteInfo
			},
			providesTags: (result) =>
				result && result.length > 0
					? [{ type: 'QuoteInfo', id: result[0].quoteId }]
					: ['QuoteInfo'],
		}),
	}),
	overrideExisting: false,
})

export const { useFetchQuoteInfoByQuoteIdQuery } = quoteInfoApi
